export default {
    statusProposta: {
        COTACAO: 1,
        PROPOSTA: 2,
        EMITIDA: 3, 
        APOLICE_APROVADA: 4,
        APOLICE_REJEITADA: 5,
        RECUSADA: 6,
        APOLICE_CANCELADA: 7,
        PENDENTE: 8,
        EM_PROCESSAMENTO: 9,
        EXPIRADA: 10,
        TERMOS_CONFIRMADOS: 11,
        APOLICE_VENCIDA: 12
    }
}


// WEBPACK FOOTER //
// ./src/helpers/status-proposta-enum.js